import { useTranslation } from "react-i18next";
import { BadgeCheck } from "lucide-react";

interface PersonalInfoProps {
  profile: any;
  onUpdate?: () => void;
}

export const PersonalInfo = ({ profile }: PersonalInfoProps) => {
  const { t } = useTranslation();
  
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2">
        <h3 className="text-lg font-medium">
          {t('profile.personalInfo.verificationTitle')}
        </h3>
        <BadgeCheck className="h-5 w-5 text-blue-500" />
      </div>
      
      {/* Display profile info instead of edit form */}
      <div className="space-y-4">
        <div>
          <div className="text-sm text-muted-foreground">
            {t('profile.personalInfo.fullName')}
          </div>
          <div className="font-medium">{profile?.full_name}</div>
        </div>
        
        {profile?.headline && (
          <div>
            <div className="text-sm text-muted-foreground">
              {t('profile.personalInfo.headline')}
            </div>
            <div className="font-medium">{profile.headline}</div>
          </div>
        )}
        
        {profile?.bio && (
          <div>
            <div className="text-sm text-muted-foreground">Bio</div>
            <div className="font-medium whitespace-pre-wrap">{profile.bio}</div>
          </div>
        )}
      </div>
    </div>
  );
};